export enum DeviceType {
  Web = 1,
  Apple = 2,
}
